export { default as OnBoarding } from './OnBoarding'
export { default as LoginAndSignup } from './LoginAndSignup'
export { default as ResetPassword } from './ResetPassword'
export { default as Dashboard } from './Dashboard'
export { default as Home } from './Home'
export { default as List } from './List'
export { default as Products } from './Products'
export { default as Meals } from './Meals'
export { default as SingleProduct } from './SingleProduct'
export { default as SingleList } from './SingleList'
export { default as OrderNow } from './OrderNow'
export { default as ProductScanning } from './ProductScanning'
export { default as ScanReceipt } from './ScanReceipt'
export { default as Blogs } from './Blogs'
export { default as UserProfile } from './UserProfile'
export { default as AboutUs } from './AboutUs'
export { default as PrivacyPolicy } from './PrivacyPolicy'
export { default as Feedback } from './Feedback'
export { default as NominateGrocery } from './NominateGrocery'
export { default as NominateBrand } from './NominateBrand'
export { default as SpreadWord } from './SpreadWord'
export { default as FAQs } from './FAQs'
export { default as OurTeam } from './OurTeam'
export { default as SingleFAQ } from './SingleFAQ'
export { default as EditProfile } from './EditProfile'
export { default as ChangePassword } from './ChangePassword'
export { default as ViewMore } from './ViewMore'
export { default as ViewMoreFiltered } from './ViewMoreFiltered'
export { default as Category } from './Category'
export { default as ProductType } from './ProductType'



// WEBPACK FOOTER //
// ./src/pages/index.js